import { type Meta } from '../types/docs';

const META: Meta = {
  description: 'An author added a content block to a collection share link page',
  name: 'block_added',
  params: [
    {
      description: 'The kind of block that was added',
      name: 'type',
      required: true,
      type: 'enum',
      values: ['image', 'video', 'links', 'text'],
    },
    {
      description: 'The name of the page the block was added to ("Home" for the root page)',
      name: 'page_name',
      required: true,
      type: 'string',
    },
  ],
};

export default META;
